/**
 * Service pour les opérations de test de commandes
 * @module admin/services/commandTestService
 */

import { apiGet, apiPost } from '../../../utils/api';

/**
 * Récupère la liste de toutes les commandes disponibles
 * @returns {Promise<Object>} Liste des commandes avec success et commands
 * @throws {Error} Si la récupération échoue
 */
export const getCommands = async () => {
  return await apiGet('/admin/commands/test/list');
};

/**
 * Teste l'exécution d'une commande avec des paramètres simulés
 * @param {string} commandName - Nom de la commande (sans le préfixe !)
 * @param {string[]} args - Arguments de la commande (optionnel)
 * @param {Object} options - Options de simulation (username, displayName, isMod, isBroadcaster, isVIP, isSubscriber)
 * @returns {Promise<Object>} Résultat du test (success, result, commandName, message, context)
 * @throws {Error} Si le test échoue
 */
export const testCommand = async (commandName, args = [], options = {}) => {
  return await apiPost('/admin/commands/test/execute', {
    commandName,
    args,
    ...options,
  });
};

/**
 * Réinitialise le compteur d'utilisation d'une commande pour le stream actuel
 * @param {string} commandName - Nom de la commande (sans le préfixe !)
 * @returns {Promise<Object>} Résultat de la réinitialisation
 * @throws {Error} Si la réinitialisation échoue
 */
export const resetLimit = async (commandName) => {
  return await apiPost('/admin/commands/test/reset-limit', {
    commandName,
  });
};
